// extracted by mini-css-extract-plugin
module.exports = {"root":"pXRZn4","share":"_6gktmC","input":"_9ec2Cy","linkBox":"zSpEPq","copy":"bm4H9W","widgetTextarea":"omM1C9","image":"q6YuF5"};